<script lang="ts" setup>
import { PropType } from 'vue';
import { Result } from '@/models/results.model';
import { Invoice } from '@/models/invoice';
import { formatCurrency } from '@/filters/filters';

const { result } = defineProps({
  result: {
    type: Object as PropType<Result<Invoice>>,
    required: true,
  },
});
</script>
<template>
  <li class="search-result">
    <router-link :to="`/balance/invoice/${result.item.number}`"
      >{{ result.item.number }}
    </router-link>
    (invoice)
    <div>
      {{ result.item.lines[0].description }}
      {{ formatCurrency(new Invoice(result.item).total) }}
    </div>
  </li>
</template>
